import { FC, useState } from "react";
import { Button, Divider, Drawer, FormLabel, Grid, IconButton, MenuItem, Select, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Typography, Tooltip } from '@mui/material'
import { useDrawerStore } from "../../../hooks/useDrawerStore";
import { CustomTabPanel } from "../../../components/common/CustomTabPanel/CustomTabPanel";
import { withStyles } from "@mui/styles";


import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import imagen_prueba from '../../../assets/image/imagen_puerta.png'
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import DeleteIcon from '@mui/icons-material/Delete';
import { Routes, useNavigate } from "react-router-dom";
import { RoutesMap } from "../../../types";

const products = [
    {id: 1, name: 'Puerta delantera derecha', discount_percentage: '6%', price: '$127.350', discount_mount: '$520.00', sku: 'SKU12345678', img: imagen_prueba},
    {id: 2, name: 'Puerta delantera derecha', discount_percentage: '6%', price: '$127.350', discount_mount: '$520.00', sku: 'SKU12345678', img: imagen_prueba},
    {id: 3, name: 'Puerta delantera derecha', discount_percentage: '6%', price: '$127.350', discount_mount: '$520.00', sku: 'SKU12345678', img: imagen_prueba},
    {id: 4, name: 'Puerta delantera derecha', discount_percentage: '6%', price: '$127.350', discount_mount: '$520.00', sku: 'SKU12345678', img: imagen_prueba}
]

const StyledTableCell = withStyles((theme) => ({
    head: {
        color: theme.palette.common.black,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell)

export const DrawerShoppingCart:FC<any> = (props):JSX.Element|any => {
    
    const { shoppingCart, setShoppingCart } = useDrawerStore()
    const navigate = useNavigate() 

    const [panel, setPanel] = useState<number>(0)
    const [quantity, setQuantity] = useState<number>(1)

    const handleChangePanel = (event: React.SyntheticEvent, newValue: number) => {
        setPanel(newValue)
    }

    return (
        <Drawer anchor="right" open={shoppingCart} onClose={() => setShoppingCart(false)} ModalProps={{ keepMounted: true }} PaperProps={{ sx: { width: 600 }}}>
            <Grid display="flex" justifyContent="center">
                <Tabs value={panel} onChange={handleChangePanel}
                    sx={{
                        "& .MuiTabs-indicator": {
                            height: 0
                        },
                        justifyContent: 'center'
                    }}
                >
                    <Tab 
                        icon={<FiberManualRecordIcon
                            sx={{
                                color: panel == 0 ? '#858585' : '#D9D9D9',
                                fontSize: panel == 0 ? 'large' : 'small',
                            }}
                        />}
                        sx={{ minWidth: '5px' }}
                    />
                    <Tab 
                        icon={<FiberManualRecordIcon
                            sx={{
                                color: panel == 1 ? '#858585' : '#D9D9D9',
                                fontSize: panel == 1 ? 'large' : 'small',
                            }}
                        />}
                        sx={{ minWidth: '5px' }}
                        // disabled
                    />
                </Tabs>
            </Grid>
            <CustomTabPanel value={panel} index={0}>
                <Grid container sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography sx={{ color: '#516E80' }}>Articulos de la cesta</Typography>
                    <Button
                        sx={{ backgroundColor: '#ffffff', border: '1px solid #516E80', borderRadius: '10px', color: '#516E80', height: '25px', padding: '6px 16px', textTransform: 'none', width: 160, "&:hover": { backgroundColor: "#ffffff" } }}
                    >Guardar cambios</Button>
                </Grid>
                <Divider sx={{ backgroundColor: '#516E80', margin: '10px 0px' }}/>
                <Grid container sx={{ marginTop: '10px' }}>
                    {
                        products.map(product => 
                            <Grid item container xs={12} md={12} sx={{ backgroundColor: '#F5F5F5', margin: '5px', padding: '5px' }}>
                                <Grid item xs={3} md={3} display='flex' justifyContent='center' alignItems='center'>
                                    <img src={product.img} alt={product.name} style={{ width: '70px', height: '70px' }}/>
                                </Grid>
                                <Grid item xs={6} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <Typography sx={{ color: '#000000', fontSize: '15px' }}>{product.sku}</Typography>
                                    <Grid>
                                        <Typography sx={{ color: '#000000' }}>{product.name}</Typography>
                                        <Typography sx={{ backgroundColor: '#FF4747', borderRadius: '5px', color: '#ffffff', padding: '2px', fontSize: '13px', marginLeft: '10px' }}>-{product.discount_percentage}</Typography>
                                        <IconButton>
                                            <EditIcon fontSize="small" />
                                        </IconButton>            
                                    </Grid>
                                    <Grid>
                                        <Typography sx={{ fontSize: '15px' }}>Cantidad:</Typography>
                                        <IconButton
                                            sx={{ background: '#516E80', marginLeft: '10px', width: '20px', height: '20px' , '&:hover': { background: '#516E80'} }}
                                            onClick={() => setQuantity(quantity-1)}
                                        >
                                            <RemoveIcon  sx={{ color: '#ffffff', width: '15px', height: '15px' }}/>
                                        </IconButton>
                                        <Typography sx={{ fontSize: '15px', marginLeft: '10px' }}>{quantity}</Typography>
                                        <IconButton
                                            sx={{ background: '#516E80', marginLeft: '10px', width: '20px', height: '20px', '&:hover': { background: '#516E80'} }}
                                            onClick={() => setQuantity(quantity+1)}
                                        >
                                            <AddIcon sx={{ color: '#ffffff', width: '15px', height: '15px' }}/>
                                        </IconButton>
                                    </Grid>
                                </Grid>
                                <Grid item xs={3} md={3} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'  }}>
                                    <Typography sx={{ color: '#000000', fontWeight: 'bolder' }}>{product.price}</Typography>
                                    <Typography sx={{ color: '#000000', textDecoration: 'line-through' }}>{product.discount_mount}</Typography>
                                </Grid>
                            </Grid>
                        )
                    }
                </Grid>
                <Grid container sx={{ marginTop: '10px', marginLeft: '5px' }}>
                    <Grid item xs={6} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography sx={{ color: '#000000', fontWeight: 'bolder' }}>Resumen</Typography>
                        <Typography sx={{ color: '#000000' }}>Puntos acumulados:</Typography>
                        <Typography sx={{ color: '#000000' }}>3 puntos</Typography>
                    </Grid>
                    <Grid item xs={6} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Grid>
                            <Typography sx={{ color: '#000000' }}>Total neto:</Typography>
                            <Typography sx={{ fontWeight: 'bolder', color: '#000000' }}>$ 382.05</Typography>
                        </Grid>
                        <Grid>
                            <Typography sx={{ color: '#000000' }}>Descuento global:</Typography>
                            <Typography sx={{ fontWeight: 'bolder', color: '#000000' }}>0%</Typography>
                            <IconButton>
                                <EditIcon fontSize="small" />
                            </IconButton>  
                        </Grid>
                        <Grid>
                            <Typography sx={{ color: '#000000' }}>Impuestos:</Typography>
                            <Typography sx={{ fontWeight: 'bolder', color: '#000000' }}>$ 5.5</Typography>
                        </Grid>
                        <Grid>
                            <Typography sx={{ color: '#000000' }}>Total bruto:</Typography>
                            <Typography sx={{ fontWeight: 'bolder', color: '#000000' }}>$ 387.55</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ marginTop: '10px' }}>
                    <Grid item xs={6}>
                        <FormLabel sx={{ color: '#000000' }}>Tipo de documento:</FormLabel>
                        <Select
                            labelId="type-document-label"
                            id="type_document"
                            value={1}
                            // onChange={handleChange}
                            fullWidth
                            size="small"
                            sx={{ borderRadius: "15px" }}
                        >
                            <MenuItem value={1}>Boleta</MenuItem>
                        </Select>
                    </Grid>
                    <Grid item xs={6}>
                        <FormLabel sx={{ color: '#000000' }}>Tipo de venta:</FormLabel>
                        <Select
                            labelId="type-sale-label"
                            id="type_sale"
                            value={1}
                            // onChange={handleChange}
                            fullWidth
                            size="small"
                            sx={{ borderRadius: "15px" }}
                        >
                            <MenuItem value={1}>Delivery</MenuItem>
                        </Select>
                    </Grid>
                </Grid>
                <Grid container sx={{ marginTop: '10px', justifyContent: 'flex-end' }}>
                    <Button
                        sx={{ backgroundColor: '#516E80', borderRadius: '10px', color: '#ffffff', height: '25px', padding: '6px 16px', textTransform: 'none', width: 160, "&:hover": { backgroundColor: "#516E80" } }}
                        onClick={()=> setPanel(1)}
                    >
                        Continuar
                    </Button>
                </Grid>
            </CustomTabPanel>
            <CustomTabPanel value={panel} index={1}>
                <Grid container sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography sx={{ color: '#516E80' }}>Datos del cliente</Typography>
                </Grid>
                <Divider sx={{ backgroundColor: '#516E80', margin: '10px 0px' }}/>
                <Grid container sx={{ marginTop: '10px' }} alignItems="center">
                    <Grid item xs={4}>
                        <FormLabel sx={{ color: '#000000' }}>RUT:</FormLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <TextField
                            id="rut"
                            type="text"
                            name="rut"
                            fullWidth
                            size="small"
                            value={'12345678-K'}
                            // onChange={handleChange}
                            variant="outlined"
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ alignItems: "center", marginTop: '10px' }}>
                    <Grid item xs={4}>
                        <FormLabel sx={{ color: '#000000' }}>Razón social / Nombre:</FormLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <TextField
                            id="rut"
                            type="text"
                            name="rut"
                            fullWidth
                            size="small"
                            value={'Softnet SPA'}
                            // onChange={handleChange}
                        />
                    </Grid>
                </Grid>
                <Divider sx={{ margin: '20px 0px 10px 0px' }}/>
                <Grid container sx={{ marginTop: '10px' }} spacing={2}>
                    <Grid item xs={6}>
                        <FormLabel sx={{ color: '#000000' }}>Condición de pago:</FormLabel>
                        <Select
                            labelId="type-sale-label"
                            id="type_sale"
                            value={1}
                            // onChange={handleChange}
                            fullWidth
                            size="small"
                            sx={{ borderRadius: "15px" }}
                        >
                            <MenuItem value={1}>30 días</MenuItem>
                        </Select>
                    </Grid>
                    <Grid item xs={6}>
                        <FormLabel sx={{ color: '#000000' }}>Forma de pago:</FormLabel>
                        <Select
                            labelId="type-sale-label"
                            id="type_sale"
                            value={1}
                            // onChange={handleChange}
                            fullWidth
                            size="small"
                            sx={{ borderRadius: "15px" }}
                        >
                            <MenuItem value={1}>Efectivo</MenuItem>
                        </Select>
                    </Grid>
                </Grid>
                <Divider sx={{ margin: '20px 0px 10px 0px' }}/>
                <Grid container sx={{ marginTop: '10px' }} spacing={2}>
                    <Grid item xs={12} display='flex' justifyContent='center' alignItems='center'>
                        <FormLabel sx={{ color: '#000000' }}>Tipo de documento:</FormLabel>
                        <Select
                            labelId="type-sale-label"
                            id="type_sale"
                            value={1}
                            // onChange={handleChange}
                            size="small"
                            sx={{ borderRadius: "15px", width: "200px", marginLeft: '10px' }}
                        >
                            <MenuItem value={1}>Orden de compra</MenuItem>
                        </Select>
                    </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ marginTop: '10px' }}>
                    <Grid item xs={6}>
                        <FormLabel sx={{ color: '#000000' }}>Folio documento:</FormLabel>
                        <TextField
                            id="folio"
                            type="text"
                            name="folio"
                            fullWidth
                            size="small"
                            value={'123456789'}
                            // onChange={handleChange}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <FormLabel sx={{ color: '#000000' }}>Razón de referencia:</FormLabel>
                        <TextField
                            id="razon"
                            type="text"
                            name="razon"
                            fullWidth
                            size="small"
                            value={'Documento'}
                            // onChange={handleChange}
                            variant="outlined"
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ marginTop: '20px' }}>
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Button
                            sx={{ backgroundColor: '#ffffff', border: '1px solid #69ABC3', borderRadius: '10px', color: '#69ABC3', height: '25px', padding: '6px 16px', textTransform: 'none', width: 160, "&:hover": { backgroundColor: "#ffffff" } }}
                        >
                            Guardar cambios
                        </Button>
                    </Grid>
                </Grid>
                <Grid container sx={{ marginTop: '20px' }}>
                    <TableContainer>
                        <Table>
                            <TableHead sx={{ background: "#D8E8F7" }}>
                                <TableRow>
                                    <StyledTableCell className="headTable" align="center" colSpan={1}>TIPO DOC</StyledTableCell>
                                    <StyledTableCell className="headTable" align="center" colSpan={1}>FOLIO</StyledTableCell>
                                    <StyledTableCell className="headTable" align="center" colSpan={1}>OBSERVACIÓN</StyledTableCell>
                                    <StyledTableCell className="headTable" align="center" colSpan={1}>OPCIONES</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow key={1}>
                                    <TableCell align="center">Orden de compra</TableCell>
                                    <TableCell align="center">123456789</TableCell>
                                    <TableCell align="center"></TableCell>
                                    <TableCell align="center">
                                    <Tooltip title="Eliminar">
                                        <IconButton size="small" color="inherit">
                                            <DeleteIcon fontSize='small' />
                                        </IconButton>
                                    </Tooltip>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
                <Grid container sx={{ marginTop: '20px', justifyContent: 'flex-end' }}>
                    <Button
                        sx={{ backgroundColor: '#516E80', borderRadius: '10px', color: '#ffffff', height: '25px', padding: '6px 16px', textTransform: 'none', width: 200, "&:hover": { backgroundColor: "#516E80" } }}
                        onClick={() => navigate({ pathname: RoutesMap.PREVIEW_DOCUMENT })}
                    >
                        Generar documento
                    </Button>
                </Grid>
            </CustomTabPanel>
        </Drawer>
    )
}